import { Modal } from '@farol-ds/react'
import { assignSubComponents } from '@farol-ds/react/utilities/internal'
import type { DialogProps as RDialogProps } from '@radix-ui/react-dialog'
import * as RDialog from '@radix-ui/react-dialog'

import { FullscreenModalContext, useFullscreenModalProvider } from './context'
import FullscreenModalContent from './subcomponents/content'
import FullscreenModalHeader from './subcomponents/header'

export interface FullscreenModalProps extends Omit<RDialogProps, 'onOpenChange'> {
  onOpenChange?: (open: boolean) => void
}

const FullscreenModalRoot: React.FC<FullscreenModalProps> = (props) => {
  const { children, ...rest } = props

  const context = useFullscreenModalProvider(props)

  const { open, onOpenChange } = context

  return (
    <FullscreenModalContext.Provider value={context}>
      <RDialog.Root {...rest} modal open={open} onOpenChange={onOpenChange}>
        {children}
      </RDialog.Root>
    </FullscreenModalContext.Provider>
  )
}

export const FullscreenModal = assignSubComponents('FullscreenModal', FullscreenModalRoot, {
  Body: Modal.Body,
  Close: Modal.Close,
  Content: FullscreenModalContent,
  Footer: Modal.Footer,
  Header: FullscreenModalHeader,
  Trigger: Modal.Trigger,
  IconClose: Modal.IconClose,
})

export * from './subcomponents/content'
export * from './subcomponents/header'
